import React from 'react';

import { branchSettingsPropType, patientPropType } from 'Shared/types';
import PropTypes from 'prop-types';
import EhrEncounterReviewContent from 'App/components/EHR/EhrEncounterReviewContent';
import PAApprovedReviewContent from 'App/features/ReferralManager/Referral/PriorAuthorization/components/EncounterModal/ApprovedReviewContent';
import PADeniedReviewContent from 'App/features/ReferralManager/Referral/PriorAuthorization/components/EncounterModal/DeniedReviewContent';
import PANotRequiredReviewContent from 'App/features/ReferralManager/Referral/PriorAuthorization/components/EncounterModal/NotRequiredReviewContent';
import { priorAuthorizationReferralDetailsPropType } from './types';

const PriorAuthorizationEncounterReviewContent = ({
    patient,
    branchSettings,
    medicationList,
    priorAuthorizationReferralDetails,
    status,
}) => {
    const renderContentByStatus = () => {
        if (status?.toUpperCase() === 'DENIED') {
            return (
                <PADeniedReviewContent
                    priorAuthorizationReferralDetails={priorAuthorizationReferralDetails}
                    status={status}
                />
            );
        }
        if (status?.toUpperCase() === 'NOT REQUIRED') {
            return (
                <PANotRequiredReviewContent
                    priorAuthorizationReferralDetails={priorAuthorizationReferralDetails}
                    status={status}
                />
            );
        }
        return (
            <PAApprovedReviewContent
                priorAuthorizationReferralDetails={priorAuthorizationReferralDetails}
                status={status}
                medicationList={medicationList}
            />
        );
    };
    return (
        <div>
            <EhrEncounterReviewContent
                patient={patient}
                branchSettings={branchSettings}
                medicationList={medicationList}
            />

            {renderContentByStatus()}
        </div>
    );
};

PriorAuthorizationEncounterReviewContent.propTypes = {
    status: PropTypes.string.isRequired,
    patient: patientPropType.isRequired,
    branchSettings: branchSettingsPropType.isRequired,
    medicationList: PropTypes.arrayOf(
        PropTypes.shape({
            medication: PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
            data: PropTypes.shape({
                authorizedQuantity: PropTypes.string,
                authorizedUom: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
                ndcSpecificApproval: PropTypes.shape({
                    id: PropTypes.string,
                    name: PropTypes.string,
                }),
                approvedNdc: PropTypes.string,
            }),
        })
    ).isRequired,
    priorAuthorizationReferralDetails: priorAuthorizationReferralDetailsPropType.isRequired,
};

export default PriorAuthorizationEncounterReviewContent;
